<mat-toolbar [ngClass]="variantClass">
  <mat-icon [ngClass]="{ 'align-start': alignIconToTop }">{{ icon }}</mat-icon>
  <span class="banner-content-text"><ng-content></ng-content></span>
</mat-toolbar>
